var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_828_614",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 32,
    width: 80,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.062 32.75H24.9375V95.25H103.062V32.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_828_614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9776 63.0861C69.8146 58.7263 62.9558 54.7182 55.9448 50.5332V75.5683C63.3224 71.0003 71.0987 66.8171 77.0081 63.0861H76.9776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9776 63.0861C69.8146 58.7263 55.9448 50.5332 55.9448 50.5332L74.4368 64.6891C74.4368 64.6891 71.0683 66.8171 76.9776 63.0861Z",
    fill: "#E8E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2934 95.1679C42.4146 94.8561 37.333 94.5753 34.2094 93.8424C32.0961 93.3554 30.2597 92.2741 28.9132 90.7058C27.8725 89.5188 27.0448 87.7078 26.4027 85.1952C25.8519 83.1019 25.6374 81.3604 25.3316 77.1062C24.8634 67.5048 24.7518 59.6551 25.3316 50.8841C25.8099 46.0404 26.0418 40.2907 29.219 36.9361C30.7192 35.3661 32.4643 34.3559 34.424 33.9382C37.4852 33.2761 50.5273 32.7529 64.0289 32.7529C77.5 32.7529 90.5711 33.2761 93.6352 33.9382C96.0832 34.4616 98.3791 36.0299 99.7271 38.0522C102.626 43.2455 102.677 49.7037 102.971 54.7554C103.093 57.1623 103.093 70.8295 102.971 73.2364C102.513 81.22 102.145 84.0447 101.104 86.9733C100.461 88.8223 99.9113 89.7977 98.9604 90.8791C97.4691 92.5432 95.5682 93.6499 93.5105 94.0521C80.6352 95.1548 69.702 95.3942 57.2934 95.1679ZM77.01 63.0889C69.8469 58.7288 62.9881 54.686 55.9771 50.501V75.5379C63.3549 70.9699 71.1326 66.7851 77.0404 63.0542L77.01 63.0889Z",
    fill: "#CD201F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2acb9dd7d2849ca23f8d2c063f7fc5c4.svg";
export { ForwardRef as ReactComponent };